import { Box, Grid, Typography, Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { DataGridPro as DataGrid } from '@mui/x-data-grid-pro';
import { useSearchParams } from 'react-router-dom';
import api from '../components/api/api';
import { getSurveyDetailsColumns } from '../components/GridColumns';
import { QuickSearchToolbar } from '../components/QuickSearch';

export const SurveyDetailsPage = () => {
  const [searchParams] = useSearchParams();
  const surveyId = searchParams.get('id');

  const [detailsData, setDetailsData] = useState([]);
  const [filteredDetails, setFilteredDetails] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!surveyId) return;

    const getData = async () => {
      setLoading(true);
      try {
        const { data } = await api.get(
          `/survey/${surveyId}/farms?surveyStatus=SUBMITTED,DRAFT&pageNumber=1&pageSize=50`
        );

        let rows = [];
        if (data && Array.isArray(data)) {
          rows = data.map((item, index) => ({
            ...item,
            id: item.fieldId || item.id || index
          }));
        } else if (data && data.farms && Array.isArray(data.farms)) {
          // In case the response is wrapped in an object
          rows = data.farms.map((item, index) => ({
            ...item,
            id: item.fieldId || item.id || index
          }));
        }

        setDetailsData(rows);
        setFilteredDetails(rows);
      } catch (err) {
        console.error('Failed to fetch survey details', err);
        setDetailsData([]);
        setFilteredDetails([]);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [surveyId]);

  const escapeRegExp = (value) => value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
    const filteredRows = detailsData.filter((row) =>
      Object.keys(row).some((field) => {
        if (
          !['fieldId', 'area', 'farmerName', 'repName', 'repPhoneNumber', 'surveyStatus'].includes(
            field
          )
        ) {
          return false;
        }
        return searchRegex.test(row[field]?.toString());
      })
    );
    setFilteredDetails(filteredRows);
  };

  const handleRowClick = (params) => {
    const { row } = params;
    const fieldId = row.id;
    const surveyId = searchParams.get('id');
    window.open(
      `/dashboard/survey-field-details?fieldId=${fieldId}&surveyId=${surveyId}`,
      '_blank'
    );
  };

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" sx={{ margin: 1 }}>
          Survey Details
        </Typography>
      </Box>

      <Grid
        item
        style={{
          flexGrow: 1,
          height: '75vh',
          width: '100%'
        }}
      >
        <DataGrid
          components={{
            Toolbar: QuickSearchToolbar
          }}
          sx={{
            '& .MuiDataGrid-row': {
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#f5f5f5'
              }
            }
          }}
          componentsProps={{
            toolbar: {
              value: searchText,
              onChange: (event) => requestSearch(event.target.value),
              clearSearch: () => requestSearch('')
            }
          }}
          loading={loading}
          rows={filteredDetails || []}
          columns={getSurveyDetailsColumns()}
          pageSize={50}
          onRowClick={handleRowClick}
          disableSelectionOnClick
        />
      </Grid>
    </Box>
  );
};
